import { render, staticRenderFns } from "./keywordAlert.vue?vue&type=template&id=8d39ee12&scoped=true"
import script from "./keywordAlert.vue?vue&type=script&lang=js"
export * from "./keywordAlert.vue?vue&type=script&lang=js"
import style0 from "./keywordAlert.vue?vue&type=style&index=0&id=8d39ee12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d39ee12",
  null
  
)

export default component.exports